/*
 * Copyright (C) 2020 Reciprocity, Inc - All Rights Reserved
 * Unauthorized use, copying, distribution, displaying, or public performance
 * of this file, via any medium, is strictly prohibited. All information
 * contained herein is proprietary and confidential and may not be shared
 * with any third party without the express written consent of Reciprocity, Inc.
 */

import Vue from 'vue';

import { ZenFormGroup } from 'zenComponents';
import { BRow, BCol, BFormInput } from 'bootstrap-vue';

interface VueInstance extends Vue {
  value: object;
}

export const methods = {
  update(this: VueInstance, diff: object) {
    this.$emit('input', {
      ...this.value,
      ...diff,
    });
  },
};

export const props = {
  value: {
    type: Object,
    required: true,
  },
};

export const components = {
  BCol,
  ZenFormGroup,
  BFormInput,
  BRow,
};
